export default "__VITE_PUBLIC_ASSET__a3d46b3f__"